export default __webpack_public_path__ + "static/media/tournament-logo.3a7dd42c.png";